import React, { useContext, useEffect, useState } from "react"

import './Informes.css';
import controlContext from "../../context/control/controlContext";
import { STATES } from "../../utils/states";
import authContext from "../../context/authentication/authContex";
import GrillaOrdenesTrabajo from "../../components/grillasInformes/GrillaOrdenesTrabajo.js";
import GrillaProcsProgramados from "../../components/grillasInformes/GrillaProcsProgramados.js";
import GrillaDocumentos from "../../components/grillasInformes/GrillaDocumentos.js";
import GrillaActivos from "../../components/grillasInformes/GrillaActivos.js";
import DashboardODT from "../../components/dashboards/DashboardsODT.js";
import DashboardActivo from "../../components/dashboards/DashboardsActivo.js";
import DashboardsReservasCanchas from "../../components/dashboards/DashboardsReservasCanchas.js";
import GrillaConsumibles from "../../components/grillasInformes/GrillaConsumibles.js";
import GrillaTareasODT from "../../components/grillasInformes/GrillaTareasODT.js";
import GrillaControlesChecklists from "../../components/grillasInformes/GrillaControlesChecklists.js";
import GrillaChecklists from "../../components/grillasInformes/GrillaChecklists.js";
import GrillaControlServicios from "../../components/grillasInformes/GrillaControlServicios.js";
import GrillaConsumoHorasMensual from "../../components/grillasInformes/GrillaConsumoHorasMensual.js";
import GrillaJugadoresObservados from "../../components/grillasInformes/GrillaJugadoresObservados.js";

const Informes = () =>{

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const [gridToShow, setGridToShow] = useState('');

    return <div className="informesView">
        {!gridToShow && <div className="multipleOptionsDiv">
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("ACTIVO")}>Activos</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("CHECKLISTS")}>Checklists</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("CONTROLSERVICIOS")}>Control de Servicios</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("CONSUMIBLES")}>Consumibles</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("CONSUMOHORASMENSUAL")}>Consumo Horas Mensual</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("CONTROLESCHECKLISTS")}>Controles por Checklists</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("DASHBOARDODT")}>Dashboard ODTs</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("DASHBOARDACTIVOS")}>Dashboard Vida Útil</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("DASHBOARDRESERVAS")}>Dashboards Reservas Canchas</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("DOCUMENTO")}>Documentos</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("JUGADORESOBSERVADOS")}>Jugadores Observados</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("OT")}>Órdenes de Trabajo</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("PROCEDIMIENTOPROGRAMADO")}>Procedimientos Programados</button>
            </div>
            <div className="optionDiv">
                <button onClick={()=>setGridToShow("TAREASODT")}>Tareas por ODTs</button>
            </div>
        </div>}
        {(gridToShow == 'OT') && <GrillaOrdenesTrabajo setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'CONSUMIBLES') && <GrillaConsumibles setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'PROCEDIMIENTOPROGRAMADO') && <GrillaProcsProgramados setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'DOCUMENTO') && <GrillaDocumentos setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'ACTIVO') && <GrillaActivos setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'DASHBOARDODT') && <DashboardODT setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'DASHBOARDACTIVOS') && <DashboardActivo setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'DASHBOARDRESERVAS') && <DashboardsReservasCanchas setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'TAREASODT') && <GrillaTareasODT setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'CONTROLESCHECKLISTS') && <GrillaControlesChecklists setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'CHECKLISTS') && <GrillaChecklists setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'CONTROLSERVICIOS') && <GrillaControlServicios setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'CONSUMOHORASMENSUAL') && <GrillaConsumoHorasMensual setGridToShow={setGridToShow} usuario={usuario}/>}
        {(gridToShow == 'JUGADORESOBSERVADOS') && <GrillaJugadoresObservados setGridToShow={setGridToShow} usuario={usuario}/>}
    </div>

}

export default Informes;